import styled from 'styled-components';
import { Select } from 'antd';
import { PURPLE } from 'utils/constants/theme';

export const LibSelect = styled(Select)`
  margin: 0px 0px 10px 0px !important;
  padding: 0px !important;
  width: 90%;
  &.simple {
    .ant-select-selection {
      border-color: transparent;
    }
    svg {
      position: static;
      height: 200px;
    }
  }
  .ant-select-selection {
    border-color: ${({ disabled }) => (disabled ? 'inherit' : PURPLE)};
    &:focus {
      position: absolute;
      top: 100%;
      box-shadow: 0 0 0 2px rgba(111, 75, 241, 0.22);
    }
  }
  .ant-select-arrow .anticon:not(.ant-select-suffix) {
    pointer-events: none;
  }
  .ant-select-selection-selected-value {
    font-size: 14px;
    color: #21303a;
  }
  .ant-select-dropdown-menu-item {
    font-size: 14px;
    color: #000000;
  }
  .ant-select-arrow {
    color: ${PURPLE};
    position: absolute !important;
    left: 92% !important;
    top: 50% !important;
  }
  .select-option-wrapper {
    display: flex;
    align-items: center;
  }
  .color-box {
    justify-content: center;
    margin-right: 5px;
  }
`;

export const rectangleStyle = (color, borderColor) => ({
  width: '23px',
  height: '15px',
  backgroundColor: color,
  borderStyle: 'solid',
  borderWidth: 1,
  borderColor: borderColor
});

export const LibOption = styled(Select.Option)``;
